import { render, staticRenderFns } from "./WarningVideo.vue?vue&type=template&id=16656452"
import script from "./WarningVideo.vue?vue&type=script&lang=js"
export * from "./WarningVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports